module.exports = __webpack_public_path__ + "assets/img/home-typical-scenarios-icon3.01fabfdf.png";